import { forwardRef } from 'react';

import styled from 'styled-components';

import { RadioGroupOptionProps } from 'ui';

import { BillingPeriod, RatePlan } from '../../types';
import { MonthlyRadioButton, YearlyRadioButton } from './RadioButtons';

interface ProductSelectorProps extends Omit<RadioGroupOptionProps, 'labelText'> {
  ratePlans: RatePlan[];
  isPrepaid: boolean;
  nextPaymentDate?: Date;
  showBadge?: boolean;
  badgeText?: React.ReactNode;
  showNewProductSelector?: boolean;
}

const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
  border: none;
  padding: 0;
  margin: 0;
`;

export const AltProductSelector = forwardRef<HTMLInputElement, ProductSelectorProps>(
  ({ ratePlans, isPrepaid, nextPaymentDate, value, ...radioProps }, ref) => {
    return (
      /* eslint-disable-next-line styled-components-a11y/no-noninteractive-element-to-interactive-role */
      <Fieldset role="radiogroup">
        {ratePlans.map((ratePlan) => {
          if (ratePlan.billingPeriod === BillingPeriod.Years) {
            return (
              <YearlyRadioButton
                key={ratePlan.billingPeriod}
                ratePlan={ratePlan}
                isPrepaid={isPrepaid}
                nextPaymentDate={nextPaymentDate}
                value={ratePlan.billingPeriod}
                checked={value === ratePlan.billingPeriod}
                {...radioProps}
                ref={ref}
              />
            );
          } else if (ratePlan.billingPeriod === BillingPeriod.Months) {
            return (
              <MonthlyRadioButton
                key={ratePlan.billingPeriod}
                ratePlan={ratePlan}
                isPrepaid={isPrepaid}
                nextPaymentDate={nextPaymentDate}
                value={ratePlan.billingPeriod}
                checked={value === ratePlan.billingPeriod}
                {...radioProps}
                ref={ref}
              />
            );
          }
          return null;
        })}
      </Fieldset>
    );
  },
);
